import script from "./DrainageStatistics.vue?vue&type=script&setup=true&lang=ts"
export * from "./DrainageStatistics.vue?vue&type=script&setup=true&lang=ts"

import "./DrainageStatistics.vue?vue&type=style&index=0&id=96bfdec0&scoped=true&lang=less"

import exportComponent from "E:\\twl\\workspace\\auxiliary-ts-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96bfdec0"]])

export default __exports__